import { memo, useMemo } from "react";

import { useTranslate } from "@/i18n/useTranslationModules";
import { useTypedSelector } from "@/store/reducers/use-typed-selector";
import { RegistrationStep, LanguagesAbbr, RegistrationStepType } from "@/types/working-model";
import { TypographyItem } from "@general-ui/typography-item/typography-item";

const GeneralContentHeader = memo((
	{ soldOut, currentStep, language }:
		{ soldOut: boolean; currentStep?: RegistrationStep; language: LanguagesAbbr; }
) => {
	const { t } = useTranslate('homepage');
	const translationUpdates = useTypedSelector(state => state.LiveEventReducer.translationUpdates);

	const text = useMemo(() => {
		if (soldOut) {
			return t('homepage:registration.soldOutHeader');
		}
		const customTitle = currentStep?.title?.[language] || currentStep?.title?.base;
		if (currentStep?.type === RegistrationStepType.general) {
			return customTitle || t('homepage:registration.Grab your spot', t('homepage:registration.Register for the event'));
		}
		if (currentStep?.type === RegistrationStepType.profile) {
			return customTitle || t("homepage:registration.Tell us about yourself");
		}
		return '';

		// must include translationUpdates to handle content re-rendering when switching languages
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentStep?.title, currentStep?.type, language, soldOut, t, translationUpdates]);

	// wrap with TypographyItem because it handles sanitizing, preventing html strings from rendering
	return <TypographyItem>{text}</TypographyItem>;
});

export default GeneralContentHeader;